import {useAuthContext} from './useAuthContext'
import {useTripsContext} from './useTripsContext'

export const useLogout = () => {
    const {dispatch} = useAuthContext()
    const { dispatch: tripsDispatch } = useTripsContext()
    const logout = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/logout`, {
                method: 'POST',
                credentials: 'include'
            })
            if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
                return
            }
            //update the auth context
            dispatch({type: 'LOGOUT'})
            tripsDispatch({type: 'SET_TRIPS', payload: null})
        } catch (error) {
            console.log(error)
            return
        }
    }
    return {logout}
}